import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import combinedReducers from './combinedReducers'

const rootReducer = (state, action) => {
  let isReset = false
  if (action.type === 'logout-success') {
    isReset = true
  }
  // whenever we return state value 'undefined', all the reducer will get reset to initial state
  return combinedReducers(isReset ? undefined : state, action)
}

const store = createStore(rootReducer, applyMiddleware(thunk))

export default store
